
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9a8.972 8.972 0 005.144-1.613.871.871 0 00.216-1.213.871.871 0 00-1.214-.216c-1.176.82-2.6 1.3-4.146 1.3A7.245 7.245 0 011.742 9 7.245 7.245 0 019 1.742 7.245 7.245 0 0116.258 9v1.161c0 .29-.083.553-.227.778a1.442 1.442 0 01-1.225.674c-.812 0-1.451-.64-1.451-1.452V9a.871.871 0 00-.066-.329.871.871 0 00-.002-.004c-.18-2.233-2.01-4.022-4.287-4.022A4.368 4.368 0 004.645 9 4.368 4.368 0 009 13.355c1.33 0 2.481-.638 3.282-1.586.569.893 1.396 1.586 2.524 1.586A3.19 3.19 0 0018 10.16V9c0-4.96-4.04-9-9-9zm0 6.387A2.6 2.6 0 0111.613 9 2.6 2.6 0 019 11.613 2.6 2.6 0 016.387 9 2.6 2.6 0 019 6.387z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    